import { render, staticRenderFns } from "./company-news-service-cn.vue?vue&type=template&id=39c2e2bd&"
import script from "./company-news-service-cn.vue?vue&type=script&lang=js&"
export * from "./company-news-service-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports